




import Vue from 'vue';
import InformationDetail from '@/components/information/information-detail.component.vue';
export default Vue.extend({
  components: {
    'information-detail': InformationDetail,
  },
});
